import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Banner } from 'src/app/model/shared/banner';
import { SharedDataService } from 'src/app/service/shared-data.service';

@Component({
  selector: 'app-api-docs-page',
  templateUrl: './api-docs-page.component.html',
  styleUrls: ['./api-docs-page.component.scss']
})
export class ApiDocsPageComponent implements OnInit {
  pageTitle = '';
  apiName = '';
  tabName = '';
  href = '';
  isTabOverride = false;

  banner: Banner = {} as Banner;
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private sharedDataService: SharedDataService, private location: Location) {}

  ngOnInit(): void {
    this.href = this.router.url.includes('#') ? this.router.url.split('#').pop() || '' : '';
  
    this.activatedRoute.params.subscribe((params) => {
      this.apiName = params['apiName'];
      this.tabName = params['tabName'];
      const pageTitle = params['pageTitle']; 
  
      this.activatedRoute.queryParams.subscribe((queryParams) => {
        this.isTabOverride = queryParams['tab'] === 'true';
      });
  
      
      if (this.apiName && this.tabName) {
        this.pageTitle = decodeURIComponent(`${this.apiName} ${this.tabName}`).trim();
      } else if (this.apiName) {
        this.pageTitle = decodeURIComponent(this.apiName).trim();
      } else if (pageTitle) {
        this.pageTitle = decodeURIComponent(pageTitle).trim();
      }
  
      //console.log(' Final pageTitle:', this.pageTitle);
  
      this.sharedDataService.sharedData.subscribe((banner) => {
        this.banner = banner;
      });
    });
  }
  
}
